import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import { WEDDING_CONFIG } from '../config';
import Footer from '../components/Footer';

const GalleryPage = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  
  // Map the URLs from config to gallery items with titles and sizes
  const galleryImages = [
    { id: 1, url: WEDDING_CONFIG.images.gallery[15], title: 'Stealing sweet glances', size: 'medium' },
    { id: 2, url: WEDDING_CONFIG.images.gallery[0], title: 'Loving You', size: 'tall' },
    { id: 3, url: WEDDING_CONFIG.images.gallery[1], title: 'Pretty in pink vibes', size: 'medium' },
    { id: 4, url: WEDDING_CONFIG.images.gallery[2], title: 'Swept off my feet', size: 'large' },
    { id: 5, url: WEDDING_CONFIG.images.gallery[3], title: 'Forever hand in hand', size: 'wide' },
    { id: 6, url: WEDDING_CONFIG.images.gallery[4], title: 'Come walk with me', size: 'medium' },
    { id: 7, url: WEDDING_CONFIG.images.gallery[5], title: 'Chilling in style', size: 'medium' },
    { id: 8, url: WEDDING_CONFIG.images.gallery[6], title: 'Glowing with pure happiness', size: 'wide' },
    { id: 9, url: WEDDING_CONFIG.images.gallery[7], title: 'Cool guy energy', size: 'tall' },
    { id: 10, url: WEDDING_CONFIG.images.gallery[8], title: 'Our Love Story', size: 'medium' },
    { id: 11, url: WEDDING_CONFIG.images.gallery[9], title: 'The look of love', size: 'wide' },
    { id: 12, url: WEDDING_CONFIG.images.gallery[10], title: 'Higher with you always', size: 'medium' },
    { id: 13, url: WEDDING_CONFIG.images.gallery[11], title: 'Our little love nest', size: 'medium' },
    { id: 14, url: WEDDING_CONFIG.images.gallery[12], title: 'Cuddled up in paradise', size: 'medium' },
    { id: 15, url: WEDDING_CONFIG.images.gallery[13], title: 'Push me towards forever', size: 'large' },
    { id: 16, url: WEDDING_CONFIG.images.gallery[14], title: 'Golden moments with you', size: 'tall' },
  ];

  const openModal = (image) => {
    setSelectedImage(image);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  return (
    <div style={styles.page}>
      <Navbar />
      
      <section style={styles.hero}>
        <h1 style={styles.heroTitle}>Our Gallery</h1>
        <p style={styles.heroSubtitle}>
          Capturing beautiful moments of our love story
        </p>
      </section>

      <section style={styles.section}>
        <div style={styles.container}>
          <div style={styles.gallery} className="masonry-gallery">
            {galleryImages.map((image) => (
              <div 
                key={image.id} 
                style={styles.galleryItem}
                className={`gallery-item ${image.size}`}
                onClick={() => openModal(image)}
              >
                <img
                  src={image.url}
                  alt={image.title}
                  style={styles.galleryImage}
                  loading="lazy"
                  onError={(e) => {
                    e.target.src = `https://via.placeholder.com/400x300/${WEDDING_CONFIG.colors.primary.slice(1)}/ffffff?text=${image.title}`;
                  }}
                />
                <div style={styles.overlay} className="overlay">
                  <h3 style={styles.imageTitle}>{image.title}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {selectedImage && (
        <div style={styles.modal} onClick={closeModal}>
          <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <button style={styles.closeButton} onClick={closeModal}>✕</button>
            <img
              src={selectedImage.url}
              alt={selectedImage.title}
              style={styles.modalImage}
              onError={(e) => {
                e.target.src = `https://via.placeholder.com/800x600/${WEDDING_CONFIG.colors.primary.slice(1)}/ffffff?text=${selectedImage.title}`;
              }}
            />
            <h3 style={styles.modalTitle}>{selectedImage.title}</h3>
          </div>
        </div>
      )}
      
      <Footer />
    </div>
  );
};

const styles = {
  page: {
    background: WEDDING_CONFIG.colors.light,
    minHeight: '100vh',
  },
  hero: {
    height: '100vh',
    background: `linear-gradient(135deg, ${WEDDING_CONFIG.colors.primary}, ${WEDDING_CONFIG.colors.secondary})`,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    textAlign: 'center',
    marginTop: '60px',
    padding: '2rem',
  },
  heroTitle: {
    fontSize: '4rem',
    fontFamily: "'Great Vibes', 'Playfair Display', serif",
    marginBottom: '1rem',
  },
  heroSubtitle: {
    fontSize: '1.3rem',
    fontWeight: '300',
  },
  section: {
    padding: '4rem 2rem',
  },
  container: {
    maxWidth: '1400px',
    margin: '0 auto',
  },
  gallery: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gridAutoRows: '200px',
    gap: '1rem',
  },
  galleryItem: {
    position: 'relative',
    borderRadius: '15px',
    overflow: 'hidden',
    cursor: 'pointer',
    boxShadow: '0 5px 15px rgba(0, 0, 0, 0.1)',
    transition: 'transform 0.3s, box-shadow 0.3s',
  },
  galleryImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    transition: 'transform 0.3s',
  },
  overlay: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    background: 'linear-gradient(to top, rgba(0,0,0,0.8), transparent)',
    padding: '2rem 1rem 1rem',
    opacity: 0,
    transition: 'opacity 0.3s',
  },
  imageTitle: {
    color: 'white',
    fontSize: '1.2rem',
    fontWeight: '600',
  },
  modal: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0, 0, 0, 0.9)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 2000,
    padding: '2rem',
  },
  modalContent: {
    position: 'relative',
    maxWidth: '90%',
    maxHeight: '90%',
    background: 'white',
    borderRadius: '20px',
    padding: '2rem',
  },
  closeButton: {
    position: 'absolute',
    top: '1rem',
    right: '1rem',
    background: WEDDING_CONFIG.colors.primary,
    color: 'white',
    border: 'none',
    borderRadius: '50%',
    width: '40px',
    height: '40px',
    fontSize: '1.5rem',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10,
  },
  modalImage: {
    maxWidth: '100%',
    maxHeight: '70vh',
    borderRadius: '10px',
  },
  modalTitle: {
    textAlign: 'center',
    marginTop: '1rem',
    color: WEDDING_CONFIG.colors.primary,
    fontSize: '1.5rem',
  }
};

// Add CSS for masonry layout and hover effects
if (typeof document !== 'undefined') {
  const style = document.createElement('style');
  style.innerHTML = `
    .gallery-item.large {
      grid-column: span 2;
      grid-row: span 2;
    }
    
    .gallery-item.wide {
      grid-column: span 2;
      grid-row: span 1;
    }
    
    .gallery-item.tall {
      grid-column: span 1;
      grid-row: span 2;
    }
    
    .gallery-item.medium {
      grid-column: span 1;
      grid-row: span 1;
    }

    /* Hover Effects */
    .gallery-item:hover {
      transform: translateY(-5px);
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
    }
    
    .gallery-item:hover img {
      transform: scale(1.1);
    }
    
    .gallery-item:hover .overlay {
      opacity: 1;
    }

    /* Mobile Responsive - All items same size on mobile */
    @media (max-width: 768px) {
      .masonry-gallery {
        grid-template-columns: repeat(2, 1fr) !important;
        grid-auto-rows: 150px !important;
        gap: 0.5rem !important;
      }
      
      .gallery-item.large,
      .gallery-item.wide,
      .gallery-item.tall,
      .gallery-item.medium {
        grid-column: span 1 !important;
        grid-row: span 1 !important;
      }
    }

    @media (max-width: 480px) {
      .masonry-gallery {
        grid-template-columns: repeat(2, 1fr) !important;
        grid-auto-rows: 120px !important;
      }
    }
  `;
  document.head.appendChild(style);
}

export default GalleryPage;